import React, { useEffect, useState } from "react";
import Adminhomemenu from "../Menus/Adminhomemenu";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function Testhistory() {
  const user = JSON.parse(localStorage.getItem("user"));
  const UID = user?.UID;

  const [tests, setTests] = useState([]);
  const [students, setStudents] = useState([]);
  const [review, setReview] = useState([]);

  const [activeTest, setActiveTest] = useState(null);
  const [activeStudent, setActiveStudent] = useState(null);

  const [loadingTests, setLoadingTests] = useState(false);
  const [loadingStudents, setLoadingStudents] = useState(false);
  const [loadingReview, setLoadingReview] = useState(false);

  /* ================= LOAD TEST LIST ================= */
  useEffect(() => {
    fetchTests();
  }, []);

  const fetchTests = async () => {
    try {
      setLoadingTests(true);
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_LIST_OF_TEST_CREATED}`;
      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ UID }),
      });
      const json = await res.json();
      if (json.res === "success") {
        setTests(json.data.reverse());
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingTests(false);
    }
  };

  /* ================= LOAD STUDENTS ================= */
  const fetchStudents = async (test) => {
    try {
      setActiveTest(test);
      setActiveStudent(null);
      setStudents([]);
      setReview([]);

      setLoadingStudents(true);
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_STUDENT_LIST_BY_TEST}`;
      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ TEST_ID: test.TEST_UID }),
      });
      const json = await res.json();
      setStudents(json.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingStudents(false);
    }
  };

  /* ================= LOAD REVIEW ================= */
  const fetchReview = async (student) => {
    try {
      setActiveStudent(student);
      setReview([]);

      setLoadingReview(true);
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_STUDENT_WISE_TEST_DETAIL}`;
      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          TEST_ID: activeTest.TEST_UID,
          UID: student.UID,
        }),
      });
      const json = await res.json();
      setReview(json.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingReview(false);
    }
  };

  /* ================= COMMON REPORT DATA ================= */
  const fetchReportData = async () => {
    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_USER_DETAIL_AS_WELL_AS_TRADE_DETAIL}`;
    const res = await fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ TEST_ID: activeTest.TEST_UID }),
    });
    const json = await res.json();

    if (json.res !== "Success") {
      alert("No report data found");
      return null;
    }
    return json.data;
  };

  /* ================= PDF ================= */
  // const downloadPDF = async () => {
  //   const data = await fetchReportData();
  //   if (!data) return;

  //   const doc = new jsPDF();
  //   doc.setFontSize(14);
  //   doc.text("EasyITI - Test Report", 14, 15);

  //   doc.setFontSize(10);
  //   doc.text(`Test Name : ${activeTest.TEST_NAME}`, 14, 25);
  //   doc.text(`Batch     : ${activeTest.BATCH_NUM}`, 14, 32);
  //   doc.text(`Date      : ${activeTest.TEST_DATE}`, 14, 39);

  //   const rows = data.map((s) => [
  //     s.FULL_NAME,
  //     s.TRADE_NAME,
  //     s.TOTAL_Q,
  //     s.TOTAL_RIGHT,
  //     s.TOTAL_WRONG,
  //     `${s.TOTAL_RIGHT}/${s.TOTAL_Q}`,
  //   ]);

  //   autoTable(doc, {
  //     head: [["Student Name", "Trade", "Total Q", "Right", "Wrong", "Marks"]],
  //     body: rows,
  //     startY: 45,
  //     theme: "grid",
  //     styles: { fontSize: 9 },
  //   });

  //   doc.save(`Test_Report_${activeTest.TEST_NAME}.pdf`);
  // };

  const downloadPDF = async () => {
    const data = await fetchReportData();
    if (!data) return;

    const doc = new jsPDF();

    const itiName = user?.ITI_NAME || "ITI NAME";

    /* 🔥 HEADER BOX */
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.rect(10, 10, 190, 30); // x, y, width, height

    /* 🔥 ITI NAME (BIG CENTER) */
    doc.setFontSize(20);
    doc.setFont(undefined, "bold");
    doc.text(itiName, 105, 22, { align: "center" });

    /* 🔥 SUBTITLE */
    doc.setFontSize(11);
    doc.setFont(undefined, "normal");
    doc.text("EasyITI Examination Report", 105, 32, { align: "center" });

    /* 🔥 TEST DETAILS */
    doc.setFontSize(10);
    doc.text(`Test Name : ${activeTest.TEST_NAME}`, 14, 50);
    doc.text(`Batch     : ${activeTest.BATCH_NUM}`, 14, 57);
    doc.text(`Date      : ${activeTest.TEST_DATE}`, 14, 64);

    /* 🔥 TABLE DATA */
    const rows = data.map((s, index) => [
      index + 1, // ✅ Serial Number
      s.FULL_NAME,
      s.TRADE_NAME,
      s.TOTAL_Q,
      s.TOTAL_RIGHT,
      s.TOTAL_WRONG,
      `${s.TOTAL_RIGHT}/${s.TOTAL_Q}`,
    ]);

    autoTable(doc, {
      head: [
        ["No", "Student Name", "Trade", "Total Q", "Right", "Wrong", "Marks"],
      ],
      body: rows,
      startY: 70,
      theme: "grid",
      styles: { fontSize: 9 },
    });

    doc.save(`${itiName}_Test_Report_${activeTest.TEST_NAME}.pdf`);
  };

  /* ================= EXCEL ================= */
  const downloadExcel = async () => {
    const data = await fetchReportData();
    if (!data) return;

    const excelData = data.map((s) => ({
      "Student Name": s.FULL_NAME,
      Trade: s.TRADE_NAME,
      "Total Questions": s.TOTAL_Q,
      Right: s.TOTAL_RIGHT,
      Wrong: s.TOTAL_WRONG,
      Marks: `${s.TOTAL_RIGHT}/${s.TOTAL_Q}`,
    }));

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    const buffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(
      new Blob([buffer], { type: "application/octet-stream" }),
      `Test_Report_${activeTest.TEST_NAME}.xlsx`,
    );
  };

  const getOptionText = (q, index) => q[`OPT${index}`];

  /* ================= UI ================= */
  return (
    <>
      <Adminhomemenu title="EasyITI" />

      <div className="container mt-5 pt-4" style={{ height: "auto" }}>
        <h4 className="text-center mb-3">Test History</h4>
        {loadingTests && (
          <div className="text-center my-3">
            <div className="spinner-border text-success" />
          </div>
        )}
        {/* TEST LIST */}
        <div className="row">
          {tests.map((t) => (
            <div className="col-md-4 mb-3" key={t.TEST_UID}>
              <div
                className={`card shadow ${
                  activeTest?.TEST_UID === t.TEST_UID ? "border-primary" : ""
                }` }
                onClick={() => fetchStudents(t)}
                style={{ cursor: "pointer" }}
              >
                <div className="card-body">
                  <h6>Batch: {t.BATCH_NUM}</h6>
                  <div>Test: {t.TEST_NAME}</div>
                  <div>Date: {t.TEST_DATE}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* STUDENT LIST */}
        {activeTest && (
          <>
            <hr />
            <div className="d-flex justify-content-between align-items-center">
              <h5>Students – Batch {activeTest.BATCH_NUM}</h5>
              <div className="d-flex gap-2">
                <button className="btn btn-danger btn-sm" onClick={downloadPDF}>
                  📄 PDF
                </button>
                <button
                  className="btn btn-success btn-sm"
                  onClick={downloadExcel}
                >
                  📊 Excel
                </button>
              </div>
            </div>

            {loadingStudents && (
              <div className="text-center my-3">
                <div className="spinner-border text-success" />
              </div>
            )}

            <div className="row">
              {students.map((s) => (
                <div className="col-md-3 mb-3" key={s.UID}>
                  <div
                    className={`card shadow text-center ${
                      activeStudent?.UID === s.UID ? "border-success" : ""
                    }`}
                    onClick={() => fetchReview(s)}
                    style={{ cursor: "pointer" }}
                  >
                    <div className="card-body">
                      <h6>{s.FULL_NAME}</h6>
                      <div>✔ Right: {s.TOTAL_RIGHT}</div>
                      <div>✖ Wrong: {s.TOTAL_WRONG}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {/* REVIEW */}
        {activeStudent && (
          <>
            <hr />
            <h5>Test Review – {activeStudent.FULL_NAME}</h5>

            {loadingReview && (
              <div className="text-center my-3">
                <div className="spinner-border text-danger" />
              </div>
            )}

            {review.map((q, i) => {
              const isRight = q.GIVEN_ANS === q.ANS_IN_SEQ;
              return (
                <div
                  key={q.QUE_UID}
                  className={`card mb-3 ${
                    isRight ? "border-success" : "border-danger"
                  }`}
                >
                  <div className="card-body">
                    <b>
                      {i + 1}. {q.QUESTION}
                    </b>
                    <ul className="mt-2">
                      {["A", "B", "C", "D"].map((k, idx) => (
                        <li
                          key={k}
                          style={{
                            color:
                              k === q.ANS_IN_SEQ
                                ? "green"
                                : k === q.GIVEN_ANS
                                  ? "red"
                                  : "black",
                          }}
                        >
                          {k}. {getOptionText(q, idx + 1)}
                        </li>
                      ))}
                    </ul>
                    <div>
                      <b>Student Answer:</b> {q.GIVEN_ANS}
                    </div>
                    <div>
                      <b>Correct Answer:</b> {q.ANS_IN_SEQ}
                    </div>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
    </>
  );
}
